module.exports = __webpack_public_path__ + "static/img/fgbg2-11.af30693.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/2/fgbg2-11.png
// module id = 56
// module chunks = 0